export const HOME = '/'
export const LOGIN = '/login'
export const SIGNUP = '/signup'
export const FORGET_PASSWORD = '/forget-password'

// cấu hình tài khoản
export const CAU_HINH_TAI_KHOAN_ROOT = '/cau-hinh'
export const CAU_HINH_TAI_KHOAN = `${CAU_HINH_TAI_KHOAN_ROOT}/cau-hinh-tai-khoan`
export const CAU_HINH_DIA_CHI_NHAN = `${CAU_HINH_TAI_KHOAN_ROOT}/cau-hinh-dia-chi-nhan`
export const CAU_HINH_TAI_KHOAN_THANH_TOAN = `${CAU_HINH_TAI_KHOAN_ROOT}/cau-hinh-tai-khoan-thanh-toan`
export const DOI_MAT_KHAU = `${CAU_HINH_TAI_KHOAN_ROOT}/doi-mat-khau`
// tạo đơn
export const ORDER = `/order`
export const TAO_DON_LE = `${ORDER}/tao-don-le`
export const TAO_DON_EXCEL = `${ORDER}/tao-excel`
export const LICH_SU_TAI_FILE = `${ORDER}/lich-su-tai-file`
export const CHI_TIET_LICH_SU_FILE = `${ORDER}/chi-tiet-lich-su-file/:id`
// tạo đơn k đăng nhập
export const TAO_DON = `/tao-don`
// quản lý đơn hàng
export const QUAN_LY = `/quan-ly`
export const QUAN_LY_DON_HANG = `${QUAN_LY}/quan-ly-don-hang`
export const THONG_KE_TIEN_HANG = `${QUAN_LY}/thong-ke-tien-hang`
export const TRA_CUU_DON_HANG = `${QUAN_LY}/thong-tin-don-hang/:maVanDon`
// tra cứu
export const TRA_CUU = `/tra-cuu`
export const UOC_TINH_CUOC = `${TRA_CUU}/uoc-tinh-cuoc`
// hỗ trợ
export const HO_TRO = `/support`
export const KHIEU_NAI = `${HO_TRO}/gop-y-khieu-nai`
// thông báo
export const THONG_BAO = `/thong-bao`
// in don hang
export const PRINT = `/print`

const routesMap = {
  HOME,
  LOGIN,
  SIGNUP,
  FORGET_PASSWORD,
  // cấu hình tài khoản
  CAU_HINH_TAI_KHOAN_ROOT,
  CAU_HINH_TAI_KHOAN,
  CAU_HINH_DIA_CHI_NHAN,
  CAU_HINH_TAI_KHOAN_THANH_TOAN,
  DOI_MAT_KHAU,
  // tạo đơn
  TAO_DON_LE,
  TAO_DON_EXCEL,
  LICH_SU_TAI_FILE,
  CHI_TIET_LICH_SU_FILE,
  // tạo đơn k đăng nhập
  TAO_DON,
  // quản lý
  QUAN_LY,
  QUAN_LY_DON_HANG,
  THONG_KE_TIEN_HANG,
  TRA_CUU_DON_HANG,
  // tra cứu
  TRA_CUU,
  UOC_TINH_CUOC,
  // hỗ trọ
  HO_TRO,
  KHIEU_NAI,
  // thông báo
  THONG_BAO,
  // In don hang
  PRINT
};

export default routesMap;
